import { ActivatedRouteSnapshot, Resolve } from '@angular/router';
import { Injectable } from '@angular/core';
import { combineLatest, merge } from 'rxjs';
import { UserDAO } from '../../../../core/services/dao/userDAO';
import { RoleDAO } from '../../../../core/services/dao/roleDAO';
import { AuthService } from '../../../../core/services/auth.service';
import { WaterBodyDAO } from '../../../../core/services/dao/waterBodyDAO';
import { map, take } from 'rxjs/operators';
import { ApiHelper } from '../../../../core/services/apiHelper';
import { environment } from '../../../../environments/environment';

@Injectable()
export class WaterBodiesResolve implements Resolve<any> {
  constructor(
    private userDAO: UserDAO,
    private roleDAO: RoleDAO,
    private waterBodyDAO: WaterBodyDAO,
    private authService: AuthService,
    private apiHelper: ApiHelper,
  ) {
    this.apiHelper.setEnvironment(environment.envName);
  }

  resolve(route: ActivatedRouteSnapshot) {
    const sessionResolve = this.authService.checkSession();
    const waterBodiesResolve = this.waterBodyDAO.load();

    return combineLatest([sessionResolve, waterBodiesResolve]).pipe(
      map(([sessionResolve, waterBodiesResolve]) => ({
        sessionResolve,
        waterBodiesResolve,
      })),
      take(1),
    );
  }
}
